import React from "react";
import { Link } from "react-router-dom";

export default () => (
  <div style={{ textAlign: "justify" }}>
    <h1 className="tc mt2">Application Guidelines</h1>
    <h2 className="fw6 f5 pt4">
      Applicants are required to have the following available for registration:
    </h2>
    <ul style={{ listStyleType: "disc" }} className="pl4 mt3">
      <li>Passport-sized photograph</li>
      <li>CV in pdf or word format (Not more than 2 pages and 600kb)</li>
    </ul>
    <p className="mt4">
      Applicants are required to register before filling the application form.
    </p>
    <ul style={{ listStyleType: "disc" }} className="pl4 mt3">
      <li>
        Only applications in respect of the advertised positions would be
        considered.
      </li>
      <li>All applicants are expected to apply for ONLY ONE position.</li>
      <li>
        Multiple applications by any applicant would attract disqualification.
      </li>
      <li>
        Upon submission, applicants would receive an email confirming that their
        application have been received
      </li>
      <li>
        The application portal will be open from 25th April to 8th May 2018
      </li>
      <li>
        Deadline for submission of applications is two (2) weeks from the date
        of our publication.
      </li>
      <li>
        Only Shortlisted applicants would be contacted for aptitude test and
        interview
      </li>
      <li>
        The maximum age for first degree or HND and MSc applicants is 28 and 32
        years respectively.
      </li>
    </ul>
    <Link to="/vacancies" className="button mt4">
      Click here to apply
    </Link>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/GuideLines.js